import { lazy, Suspense, type ComponentProps } from 'react';
import { useI18n } from '../../i18n';
import type { ShapeSection as Section } from './ShapeSection';

/** The « Forme » section in its own chunk: the drawing code is not part of the first load. */
const ShapeSection = lazy(() => import('./ShapeSection').then((m) => ({ default: m.ShapeSection })));

export function LazyShapeSection(props: ComponentProps<typeof Section>) {
  const { t } = useI18n();
  return (
    <Suspense
      fallback={
        <p className="min-h-[12rem] text-sm text-muted" data-testid="shape-loading">
          {t('shape.loading')}
        </p>
      }
    >
      <ShapeSection {...props} />
    </Suspense>
  );
}
